﻿import { IEditor } from "../interface/editor";
import { ValidatorError } from "../types/validator-error";
import { ValidatorFn } from "../types/validator-fn";
import { ValidatorParam } from "../interface/validator-param";
import { isValidatorDisabled } from "./is-validator-disabled";


export interface numberValidatorParam extends ValidatorParam {
    min?: number;
    max?: number;
    integerOnly?: boolean;
}

export function numberValidator(param: numberValidatorParam): ValidatorFn {
    return (editor: IEditor): ValidatorError | null => {
        if (isValidatorDisabled(param, editor)) {
            return null;
        }

        if (editor.value === undefined || editor.value == null || editor.value === '') {
            return null;
        }

        let message='Validate Failed';
        if(param.message) {
            message= param.message;
        }

        const num = Number(editor.value);
        if (isNaN(num)) {
            return  { message: message };
        }

        if (param.integerOnly) {
            const intValue = parseInt(editor.value, 10);
            if (intValue !== num) {
                return { message: message };
            }
        }
        if (param.min) {
            if (!isNaN(param.min) && num < param.min) {
                return { message: message };
            }
        }
        if (param.max) {
            if (!isNaN(param.max) && num > param.max) {
                return { message: message };
            }
        }

        return null;
    };
}
